import { cn as e } from "./utils.es.js";
import * as t from "react";
import n, { useCallback as r, useEffect as i, useMemo as a, useRef as o, useState as s } from "react";
import { Popover as c } from "@base-ui/react/popover";
import { Fragment as l, jsx as u, jsxs as d } from "react/jsx-runtime";
import { Drawer as f } from "vaul";
import { useRender as p } from "@base-ui/react/use-render";
import { cva as m } from "class-variance-authority";
import { Checkbox as h } from "@base-ui/react/checkbox";
import { CheckIcon as g, ChevronDownIcon as _, ChevronLeftIcon as v, ChevronRightIcon as y, ChevronUpIcon as b, CircleIcon as x, SearchIcon as S, SquareCheckIcon as ee, SquareIcon as C, XIcon as w } from "lucide-react";
import { Dialog as T } from "@base-ui/react/dialog";
import { Command as E } from "cmdk";
import { Avatar as D } from "@base-ui/react/avatar";
import { Menu as O } from "@base-ui/react/menu";
import { Select as k } from "@base-ui/react/select";
import { Tooltip as A } from "@base-ui/react/tooltip";
import { Tabs as j } from "@base-ui/react/tabs";
import { DayPicker as M } from "react-day-picker";
import { ScrollArea as N } from "@base-ui/react/scroll-area";
import { Switch as P } from "@base-ui/react/switch";
import { ToggleGroup as te } from "@base-ui/react/toggle-group";
import { Toggle as F } from "@base-ui/react/toggle";
import { useTheme as I } from "next-themes";
import { Toaster as ne } from "sonner";
//#region src/components/ui/popover.tsx
var re = c.Root, L = c.Trigger, R = t.forwardRef(({ className: t, align: n = "center", side: r, sideOffset: i = 4, allowPropagationForKeys: a, onKeyDown: o, ...s }, l) => /* @__PURE__ */ u(c.Portal, { children: /* @__PURE__ */ u(c.Positioner, {
	align: n,
	side: r,
	sideOffset: i,
	className: e("z-50", typeof t == "string" ? t : void 0),
	children: /* @__PURE__ */ u(c.Popup, {
		ref: l,
		onKeyDown: (e) => {
			if (a?.length) for (let t of a) e.key !== t && e.stopPropagation();
			o?.(e);
		},
		className: e("w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none", "origin-[var(--transform-origin)] transition-[scale,opacity] duration-150 ease-out", "data-[ending-style]:opacity-0 data-[ending-style]:scale-95", t),
		...s
	})
}) }));
R.displayName = "PopoverContent";
//#endregion
//#region src/components/ui/drawer.tsx
var z = ({ shouldScaleBackground: e = !0, ...t }) => /* @__PURE__ */ u(f.Root, {
	shouldScaleBackground: e,
	...t
});
z.displayName = "Drawer";
var B = f.Trigger, V = f.Portal, H = f.Close, U = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(f.Overlay, {
	ref: r,
	className: e("fixed inset-0 z-50 bg-black/10", t),
	...n
}));
U.displayName = f.Overlay.displayName;
var W = t.forwardRef(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ d(V, { children: [/* @__PURE__ */ u(U, {}), /* @__PURE__ */ d(f.Content, {
	ref: i,
	"aria-describedby": void 0,
	className: e("fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col rounded-t-sm border bg-background", t),
	...r,
	children: [/* @__PURE__ */ u("div", { className: "mx-auto mt-4 h-2 w-[100px] rounded-full bg-muted" }), n]
})] }));
W.displayName = "DrawerContent";
var G = ({ className: t, ...n }) => /* @__PURE__ */ u("div", {
	className: e("grid gap-1.5 p-4 text-center sm:text-left", t),
	...n
});
G.displayName = "DrawerHeader";
var ie = ({ className: t, ...n }) => /* @__PURE__ */ u("div", {
	className: e("mt-auto flex flex-col gap-2 p-4", t),
	...n
});
ie.displayName = "DrawerFooter";
var K = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(f.Title, {
	ref: r,
	className: e("text-lg font-semibold leading-none tracking-tight", t),
	...n
}));
K.displayName = f.Title.displayName;
var q = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(f.Description, {
	ref: r,
	className: e("text-sm text-muted-foreground", t),
	...n
}));
q.displayName = f.Description.displayName;
//#endregion
//#region src/hooks/useMediaQuery.ts
function J(e) {
	let t = (e) => typeof window > "u" ? !1 : window.matchMedia(e).matches, [n, r] = s(t(e));
	function a() {
		r(t(e));
	}
	return i(() => {
		let t = window.matchMedia(e);
		return a(), t.addEventListener("change", a), () => {
			t.removeEventListener("change", a);
		};
	}, [e]), n;
}
//#endregion
//#region src/components/ui/buttonVariants.tsx
var Y = m("inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50", {
	variants: {
		variant: {
			default: "bg-primary text-primary-foreground hover:bg-primary/90",
			destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
			outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
			secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
			ghost: "hover:bg-accent hover:text-accent-foreground",
			link: "text-primary underline-offset-4 hover:underline",
			icon: "border-none hover:bg-accent hover:text-accent-foreground"
		},
		size: {
			default: "h-10 px-4 py-2",
			xs: "h-7 px-2",
			sm: "h-9 rounded-md px-3",
			lg: "h-11 rounded-md px-8",
			icon: "h-10 w-10"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
}), X = t.forwardRef(({ className: t, variant: n, size: r, render: i, children: a, ...o }, s) => {
	let c = e(Y({
		variant: n,
		size: r,
		className: t
	}));
	return p({
		render: i,
		props: {
			className: c,
			children: a,
			...o
		},
		ref: s,
		defaultTagName: "button"
	});
});
X.displayName = "Button";
//#endregion
//#region src/components/ui/popoverDrawer.tsx
function ae({ triggerLabel: e, children: t, open: r, setOpen: i, modal: a }) {
	let o = J("(min-width: 768px)"), s = (e) => {
		i(e);
	};
	return o ? /* @__PURE__ */ d(re, {
		open: r,
		onOpenChange: s,
		modal: a,
		children: [/* @__PURE__ */ u(L, { render: /* @__PURE__ */ u(X, {
			variant: "outline",
			size: "xs",
			className: "w-fit font-sans font-normal whitespace-nowrap p-2",
			onKeyDown: (e) => {
				e.key !== "Escape" && e?.stopPropagation();
			},
			children: e
		}) }), /* @__PURE__ */ u(R, {
			className: "min-w-[200px] w-fit p-0 max-w-[400px]",
			align: "center",
			side: "right",
			onKeyDown: (e) => {
				e.key === "Escape" && (e.stopPropagation(), i(!1));
			},
			children: n.cloneElement(t)
		})]
	}) : /* @__PURE__ */ d(z, {
		open: r,
		onOpenChange: s,
		children: [
			/* @__PURE__ */ u(K, {}),
			/* @__PURE__ */ u(q, {}),
			/* @__PURE__ */ u(B, {
				asChild: !0,
				children: /* @__PURE__ */ u(X, {
					variant: "outline",
					size: "xs",
					className: "justify-start px-2 font-sans font-normal whitespace-nowrap text-ellipsis",
					onKeyDown: (e) => {
						e.key !== "Escape" && e?.stopPropagation();
					},
					children: e
				})
			}),
			/* @__PURE__ */ u(W, { children: /* @__PURE__ */ u("div", {
				className: "mt-4 border-t",
				children: n.cloneElement(t)
			}) })
		]
	});
}
//#endregion
//#region src/components/ui/separator.tsx
var Z = t.forwardRef(({ className: t, orientation: n = "horizontal", decorative: r = !0, ...i }, a) => /* @__PURE__ */ u("div", {
	ref: a,
	role: r ? "none" : "separator",
	"aria-orientation": r ? void 0 : n,
	"data-orientation": n,
	className: e("shrink-0 bg-border", n === "horizontal" ? "h-px w-full" : "h-full w-px", t),
	...i
}));
Z.displayName = "Separator";
//#endregion
//#region src/components/ui/buttonGroup.tsx
var oe = m("flex w-fit items-stretch [&>*]:focus-visible:z-10 [&>*]:focus-visible:relative [&>[data-slot=select-trigger]:not([class*=\"w-\"])]:w-fit [&>input]:flex-1 has-[select[aria-hidden=true]:last-child]:[&>[data-slot=select-trigger]:last-of-type]:rounded-r-md has-[>[data-slot=button-group]]:gap-2", {
	variants: { orientation: {
		horizontal: "[&>*:not(:first-child)]:rounded-l-none [&>*:not(:first-child)]:border-l-0 [&>*:not(:last-child)]:rounded-r-none",
		vertical: "flex-col [&>*:not(:first-child)]:rounded-t-none [&>*:not(:first-child)]:border-t-0 [&>*:not(:last-child)]:rounded-b-none"
	} },
	defaultVariants: { orientation: "horizontal" }
});
function se({ className: t, orientation: n, ...r }) {
	return /* @__PURE__ */ u("div", {
		role: "group",
		"data-slot": "button-group",
		"data-orientation": n,
		className: e(oe({ orientation: n }), t),
		...r
	});
}
function ce({ className: t, orientation: n = "vertical", ...r }) {
	return /* @__PURE__ */ u(Z, {
		"data-slot": "button-group-separator",
		orientation: n,
		className: e("bg-input relative !m-0 self-stretch data-[orientation=vertical]:h-auto", t),
		...r
	});
}
//#endregion
//#region src/components/ui/input.tsx
var le = t.forwardRef(({ className: t, type: n, ...r }, i) => /* @__PURE__ */ u("input", {
	type: n,
	className: e("flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50", t),
	ref: i,
	...r
}));
le.displayName = "Input";
//#endregion
//#region src/components/ui/alert.tsx
var ue = m("relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground", {
	variants: { variant: {
		default: "bg-background text-foreground",
		destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive"
	} },
	defaultVariants: { variant: "default" }
}), de = t.forwardRef(({ className: t, variant: n, ...r }, i) => /* @__PURE__ */ u("div", {
	ref: i,
	role: "alert",
	className: e(ue({ variant: n }), t),
	...r
}));
de.displayName = "Alert";
var fe = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u("h5", {
	ref: r,
	className: e("mb-1 font-medium leading-none tracking-tight", t),
	...n
}));
fe.displayName = "AlertTitle";
var pe = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u("div", {
	ref: r,
	className: e("text-sm [&_p]:leading-relaxed", t),
	...n
}));
pe.displayName = "AlertDescription";
//#endregion
//#region src/components/ui/checkbox.tsx
var me = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(h.Root, {
	ref: r,
	className: e("peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[checked]:bg-primary data-[checked]:text-primary-foreground", t),
	...n,
	children: /* @__PURE__ */ u(h.Indicator, {
		className: e("flex items-center justify-center text-current"),
		children: /* @__PURE__ */ u(g, { className: "h-4 w-4" })
	})
}));
me.displayName = "Checkbox";
//#endregion
//#region src/components/ui/sheet.tsx
var he = T.Root, ge = T.Portal, _e = T.Trigger, ve = T.Close, Q = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(T.Backdrop, {
	className: e("fixed inset-0 z-50 transition-opacity duration-200", "data-[starting-style]:opacity-0 data-[ending-style]:opacity-0", t),
	...n,
	ref: r
}));
Q.displayName = "SheetOverlay";
var ye = m("fixed z-50 gap-4 bg-background p-6 shadow-2xl transition-transform duration-200 ease-in-out", {
	variants: { side: {
		top: "inset-x-0 top-0 border-b data-[starting-style]:-translate-y-full data-[ending-style]:-translate-y-full",
		bottom: "inset-x-0 bottom-0 border-t data-[starting-style]:translate-y-full data-[ending-style]:translate-y-full",
		left: "inset-y-0 left-0 h-full w-3/4 border-r data-[starting-style]:-translate-x-full data-[ending-style]:-translate-x-full sm:max-w-sm",
		right: "inset-y-0 right-0 h-full w-3/4 border-l data-[starting-style]:translate-x-full data-[ending-style]:translate-x-full sm:max-w-sm"
	} },
	defaultVariants: { side: "right" }
}), be = t.forwardRef(({ side: t = "right", className: n, children: r, defaultClose: i = !1, allowPropagationForKeys: a, container: o, onKeyDown: s, ...c }, l) => /* @__PURE__ */ d(ge, {
	container: o,
	children: [/* @__PURE__ */ u(Q, {}), /* @__PURE__ */ d(T.Popup, {
		onKeyDown: (e) => {
			if (a?.length) for (let t of a) e.key !== t && e.stopPropagation();
			s?.(e);
		},
		ref: l,
		className: e(ye({ side: t }), n),
		...c,
		children: [r, i && /* @__PURE__ */ u(T.Close, {
			className: "absolute right-2 top-2 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none",
			render: /* @__PURE__ */ d(X, {
				variant: "ghost",
				className: "w-9 px-0",
				children: [/* @__PURE__ */ u(w, {}), /* @__PURE__ */ u("span", {
					className: "sr-only",
					children: "Close"
				})]
			})
		})]
	})]
}));
be.displayName = "SheetContent";
var xe = ({ className: t, ...n }) => /* @__PURE__ */ u("div", {
	className: e("flex flex-col space-y-2 text-center sm:text-left", t),
	...n
});
xe.displayName = "SheetHeader";
var Se = ({ className: t, ...n }) => /* @__PURE__ */ u("div", {
	className: e("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", t),
	...n
});
Se.displayName = "SheetFooter";
var Ce = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(T.Title, {
	ref: r,
	className: e("text-lg font-semibold text-foreground", t),
	...n
}));
Ce.displayName = "SheetTitle";
var we = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(T.Description, {
	ref: r,
	className: e("text-sm text-muted-foreground", t),
	...n
}));
we.displayName = "SheetDescription";
//#endregion
//#region src/components/ui/dialog.tsx
var Te = T.Root, Ee = T.Portal, De = T.Trigger, Oe = T.Close, ke = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(T.Backdrop, {
	ref: r,
	className: e("fixed inset-0 z-50 bg-black/10", "transition-opacity duration-200", "data-[ending-style]:opacity-0", t),
	...n
}));
ke.displayName = "DialogOverlay";
var Ae = t.forwardRef(({ className: t, children: n, onOpenChangeProvided: r = !1, onKeyDown: i, ...a }, o) => /* @__PURE__ */ d(Ee, { children: [/* @__PURE__ */ u(ke, {}), /* @__PURE__ */ d(T.Popup, {
	onKeyDown: (e) => {
		e.key !== "Escape" && e.stopPropagation(), i?.(e);
	},
	ref: o,
	className: e("fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg xl:h-auto overflow-y-auto max-h-[92dvh] translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg sm:rounded-lg md:w-full focus-visible:outline-none", "transition-[scale,opacity] duration-200", "data-[ending-style]:opacity-0 data-[ending-style]:scale-95", t),
	...a,
	children: [n, r && /* @__PURE__ */ u(T.Close, {
		"data-testid": "dialog-close",
		className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none disabled:pointer-events-none",
		children: /* @__PURE__ */ u(w, { className: "h-4 w-4" })
	})]
})] }));
Ae.displayName = "DialogContent";
var je = ({ className: t, ...n }) => /* @__PURE__ */ u("div", {
	className: e("flex flex-col space-y-1.5 text-center sm:text-left", t),
	...n
});
je.displayName = "DialogHeader";
var Me = ({ className: t, ...n }) => /* @__PURE__ */ u("div", {
	className: e("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", t),
	...n
});
Me.displayName = "DialogFooter";
var Ne = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(T.Title, {
	ref: r,
	className: e("text-lg font-semibold leading-none tracking-tight", t),
	...n
}));
Ne.displayName = "DialogTitle";
var Pe = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(T.Description, {
	ref: r,
	className: e("text-sm text-muted-foreground", t),
	...n
}));
Pe.displayName = "DialogDescription";
//#endregion
//#region src/components/ui/command.tsx
var $ = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(E, {
	ref: r,
	className: e("flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground", t),
	...n
}));
$.displayName = E.displayName;
var Fe = ({ children: e, ...t }) => /* @__PURE__ */ u(Te, {
	...t,
	children: /* @__PURE__ */ u(Ae, {
		className: "overflow-hidden p-0 shadow-lg",
		children: /* @__PURE__ */ u($, {
			className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5",
			children: e
		})
	})
}), Ie = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ d("div", {
	className: "flex items-center border-b px-3",
	"cmdk-input-wrapper": "",
	children: [/* @__PURE__ */ u(S, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }), /* @__PURE__ */ u(E.Input, {
		ref: r,
		className: e("flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50", t),
		...n
	})]
}));
Ie.displayName = E.Input.displayName;
var Le = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(E.List, {
	ref: r,
	className: e("max-h-[300px] overflow-y-auto overflow-x-hidden", t),
	...n
}));
Le.displayName = E.List.displayName;
var Re = t.forwardRef((e, t) => /* @__PURE__ */ u(E.Empty, {
	ref: t,
	className: "py-6 text-center text-sm",
	...e
}));
Re.displayName = E.Empty.displayName;
var ze = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(E.Group, {
	ref: r,
	className: e("overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground", t),
	...n
}));
ze.displayName = E.Group.displayName;
var Be = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(E.Separator, {
	ref: r,
	className: e("-mx-1 h-px bg-border", t),
	...n
}));
Be.displayName = E.Separator.displayName;
var Ve = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(E.Item, {
	ref: r,
	className: e("relative flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none hover:bg-accent hover:text-accent-foreground data-[disabled=true]:pointer-events-none data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", t),
	...n
}));
Ve.displayName = E.Item.displayName;
var He = ({ className: t, ...n }) => /* @__PURE__ */ u("span", {
	className: e("ml-auto text-xs tracking-widest text-muted-foreground", t),
	...n
});
He.displayName = "CommandShortcut";
//#endregion
//#region src/components/ui/avatar.tsx
var Ue = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(D.Root, {
	ref: r,
	className: e("flex h-10 w-10 shrink-0 overflow-hidden rounded-full", t),
	...n
}));
Ue.displayName = "Avatar";
var We = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(D.Image, {
	ref: r,
	className: e("aspect-square h-full w-full", t),
	...n
}));
We.displayName = "AvatarImage";
var Ge = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(D.Fallback, {
	ref: r,
	className: e("flex h-full w-full items-center justify-center rounded-full bg-muted", t),
	...n
}));
Ge.displayName = "AvatarFallback";
//#endregion
//#region src/components/ui/table.tsx
var Ke = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u("table", {
	ref: r,
	className: e("w-full caption-bottom text-sm border-separate border-spacing-0", t),
	...n
}));
Ke.displayName = "Table";
var qe = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u("thead", {
	ref: r,
	className: e("[&_tr]:border-b", t),
	...n
}));
qe.displayName = "TableHeader";
var Je = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u("tbody", {
	ref: r,
	className: e("[&_tr:last-child]:border-0 [&_tr:first-child]:border-t-0", t),
	...n
}));
Je.displayName = "TableBody";
var Ye = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u("tfoot", {
	ref: r,
	className: e("bg-primary font-medium text-primary-foreground", t),
	...n
}));
Ye.displayName = "TableFooter";
var Xe = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u("tr", {
	ref: r,
	className: e("border-b transition-colors hover:bg-muted data-[state=focused]:bg-table-focused data-[state=selected]:bg-table-selected", t),
	...n
}));
Xe.displayName = "TableRow";
var Ze = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u("th", {
	ref: r,
	className: e("border-y h-8 px-2 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0", t),
	...n
}));
Ze.displayName = "TableHead";
var Qe = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u("td", {
	ref: r,
	className: e("p-2 align-middle [&:has([role=checkbox])]:pr-0", t),
	...n
}));
Qe.displayName = "TableCell";
var $e = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u("caption", {
	ref: r,
	className: e("mt-4 text-sm text-muted-foreground", t),
	...n
}));
$e.displayName = "TableCaption";
//#endregion
//#region src/components/ui/dropdown-menu.tsx
var et = O.Root, tt = O.Trigger, nt = O.Group;
O.Portal;
var rt = O.SubmenuRoot, it = O.RadioGroup, at = ["origin-[var(--transform-origin)] transition-[scale,opacity] duration-150 ease-out", "data-[ending-style]:opacity-0 data-[ending-style]:scale-95"].join(" "), ot = t.forwardRef(({ className: t, inset: n, children: r, ...i }, a) => /* @__PURE__ */ d(O.SubmenuTrigger, {
	ref: a,
	className: e("flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[highlighted]:bg-accent data-[popup-open]:bg-accent", n && "pl-8", t),
	...i,
	children: [r, /* @__PURE__ */ u(y, { className: "ml-auto h-4 w-4" })]
}));
ot.displayName = "DropdownMenuSubTrigger";
var st = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(O.Portal, { children: /* @__PURE__ */ u(O.Positioner, {
	className: e("z-50", typeof t == "string" ? t : void 0),
	children: /* @__PURE__ */ u(O.Popup, {
		ref: r,
		className: e("min-w-32 overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg", at, t),
		...n
	})
}) }));
st.displayName = "DropdownMenuSubContent";
var ct = t.forwardRef(({ className: t, align: n, side: r, sideOffset: i = 4, ...a }, o) => /* @__PURE__ */ u(O.Portal, { children: /* @__PURE__ */ u(O.Positioner, {
	align: n,
	side: r,
	sideOffset: i,
	className: e("z-50", typeof t == "string" ? t : void 0),
	children: /* @__PURE__ */ u(O.Popup, {
		ref: o,
		className: e("min-w-32 overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md", at, t),
		...a
	})
}) }));
ct.displayName = "DropdownMenuContent";
var lt = t.forwardRef(({ className: t, inset: n, ...r }, i) => /* @__PURE__ */ u(O.Item, {
	ref: i,
	className: e("relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground hover:bg-accent hover:text-accent-foreground data-[highlighted]:bg-accent data-[highlighted]:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50", n && "pl-8", t),
	...r
}));
lt.displayName = "DropdownMenuItem";
var ut = t.forwardRef(({ className: t, children: n, checked: r, ...i }, a) => /* @__PURE__ */ d(O.CheckboxItem, {
	ref: a,
	className: e("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground hover:bg-accent hover:text-accent-foreground data-[highlighted]:bg-accent data-[highlighted]:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50", t),
	checked: r,
	...i,
	children: [/* @__PURE__ */ u("span", {
		className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
		children: /* @__PURE__ */ u(O.CheckboxItemIndicator, { children: /* @__PURE__ */ u(g, { className: "h-4 w-4" }) })
	}), n]
}));
ut.displayName = "DropdownMenuCheckboxItem";
var dt = t.forwardRef(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ d(O.RadioItem, {
	ref: i,
	className: e("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground hover:bg-accent hover:text-accent-foreground data-[highlighted]:bg-accent data-[highlighted]:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50", t),
	...r,
	children: [/* @__PURE__ */ u("span", {
		className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
		children: /* @__PURE__ */ u(O.RadioItemIndicator, { children: /* @__PURE__ */ u(x, { className: "h-2 w-2 fill-current" }) })
	}), n]
}));
dt.displayName = "DropdownMenuRadioItem";
var ft = t.forwardRef(({ className: t, inset: n, ...r }, i) => /* @__PURE__ */ u("div", {
	ref: i,
	className: e("px-2 py-1.5 text-sm font-semibold", n && "pl-8", t),
	...r
}));
ft.displayName = "DropdownMenuLabel";
var pt = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(O.Separator, {
	ref: r,
	className: e("-mx-1 my-1 h-px bg-muted", t),
	...n
}));
pt.displayName = "DropdownMenuSeparator";
var mt = ({ className: t, ...n }) => /* @__PURE__ */ u("span", {
	className: e("ml-auto text-xs tracking-widest opacity-60", t),
	...n
});
mt.displayName = "DropdownMenuShortcut";
//#endregion
//#region src/components/ui/select.tsx
var ht = (e, n) => {
	t.Children.forEach(e, (e) => {
		if (!t.isValidElement(e)) return;
		let r = e;
		r.type === wt && typeof r.props.value == "string" && n.set(r.props.value, r.props.children), r.props && "children" in r.props && r.props.children !== void 0 && ht(r.props.children, n);
	});
}, gt = ({ value: e, defaultValue: n, onValueChange: r, children: i, items: a, ...o }) => {
	let s = t.useMemo(() => {
		if (r) return (e) => r(String(e));
	}, [r]), c = t.useMemo(() => {
		if (a !== void 0) return a;
		let e = /* @__PURE__ */ new Map();
		return ht(i, e), Object.fromEntries(e);
	}, [a, i]);
	return /* @__PURE__ */ u(k.Root, {
		items: c,
		...e !== void 0 && { value: e },
		...n !== void 0 && { defaultValue: n },
		...s && { onValueChange: s },
		...o,
		children: i
	});
}, _t = k.Group, vt = k.Value, yt = t.forwardRef(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ d(k.Trigger, {
	ref: i,
	className: e("flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background data-placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1", t),
	...r,
	children: [n, /* @__PURE__ */ u(k.Icon, { render: /* @__PURE__ */ u(_, { className: "h-4 w-4 opacity-50" }) })]
}));
yt.displayName = "SelectTrigger";
var bt = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(k.ScrollUpArrow, {
	ref: r,
	className: e("flex cursor-default items-center justify-center py-1", t),
	...n,
	children: /* @__PURE__ */ u(b, { className: "h-4 w-4" })
}));
bt.displayName = "SelectScrollUpButton";
var xt = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(k.ScrollDownArrow, {
	ref: r,
	className: e("flex cursor-default items-center justify-center py-1", t),
	...n,
	children: /* @__PURE__ */ u(_, { className: "h-4 w-4" })
}));
xt.displayName = "SelectScrollDownButton";
var St = t.forwardRef(({ className: t, children: n, align: r, side: i, sideOffset: a, ...o }, s) => /* @__PURE__ */ u(k.Portal, { children: /* @__PURE__ */ u(k.Positioner, {
	align: r,
	side: i,
	sideOffset: a,
	className: e("z-50", typeof t == "string" ? t : void 0),
	children: /* @__PURE__ */ d(k.Popup, {
		ref: s,
		className: e("relative max-h-(--available-height) min-w-(--anchor-width) overflow-y-auto overflow-x-hidden rounded-md border bg-popover text-popover-foreground shadow-md", "origin-(--transform-origin) transition-[scale,opacity] duration-150 ease-out", "data-ending-style:opacity-0 data-ending-style:scale-95", t),
		...o,
		children: [
			/* @__PURE__ */ u(bt, {}),
			/* @__PURE__ */ u(k.List, {
				className: "p-1",
				children: n
			}),
			/* @__PURE__ */ u(xt, {})
		]
	})
}) }));
St.displayName = "SelectContent";
var Ct = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(k.GroupLabel, {
	ref: r,
	className: e("py-1.5 pl-8 pr-2 text-sm font-semibold", t),
	...n
}));
Ct.displayName = "SelectLabel";
var wt = t.forwardRef(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ d(k.Item, {
	ref: i,
	className: e("relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-highlighted:bg-accent data-highlighted:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50", t),
	...r,
	children: [/* @__PURE__ */ u("span", {
		className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
		children: /* @__PURE__ */ u(k.ItemIndicator, { children: /* @__PURE__ */ u(g, { className: "h-4 w-4" }) })
	}), /* @__PURE__ */ u(k.ItemText, { children: n })]
}));
wt.displayName = "SelectItem";
var Tt = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(k.Separator, {
	ref: r,
	className: e("-mx-1 my-1 h-px bg-muted", t),
	...n
}));
Tt.displayName = "SelectSeparator";
//#endregion
//#region src/components/ui/badgeVariants.tsx
var Et = m("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2", {
	variants: { variant: {
		default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
		secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
		destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
		outline: "text-foreground"
	} },
	defaultVariants: { variant: "default" }
});
//#endregion
//#region src/components/ui/badge.tsx
function Dt({ className: t, variant: n, ...r }) {
	return /* @__PURE__ */ u("div", {
		className: e(Et({ variant: n }), t),
		...r
	});
}
//#endregion
//#region src/components/ui/tooltip.tsx
var Ot = t.forwardRef(({ className: t, sideOffset: n = 4, side: r, ...i }, a) => /* @__PURE__ */ u(A.Positioner, {
	sideOffset: n,
	side: r,
	className: e(
		"z-[9999999999]",
		/* v8 ignore next -- defensive: Base UI accepts function className but wrapper only forwards strings */
		typeof t == "string" ? t : void 0
	),
	children: /* @__PURE__ */ u(A.Popup, {
		ref: a,
		className: e("overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md", "transition-[scale,opacity] duration-150 ease-out", "data-[ending-style]:opacity-0 data-[ending-style]:scale-95", t),
		...i
	})
}));
Ot.displayName = "TooltipContent";
var kt = ({ content: e, children: t, defaultOpen: n, open: r }) => /* @__PURE__ */ u(A.Provider, { children: /* @__PURE__ */ d(A.Root, {
	defaultOpen: n,
	open: r,
	children: [/* @__PURE__ */ u(A.Trigger, { render: /* @__PURE__ */ u("span", { children: t }) }), /* @__PURE__ */ u(A.Portal, { children: /* @__PURE__ */ u(Ot, { children: e }) })]
}) }), At = j.Root, jt = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(j.List, {
	ref: r,
	className: e("inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground", t),
	...n
}));
jt.displayName = "TabsList";
var Mt = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(j.Tab, {
	ref: r,
	className: e("inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-background data-[active]:text-foreground data-[active]:shadow-sm", t),
	...n
}));
Mt.displayName = "TabsTrigger";
var Nt = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(j.Panel, {
	ref: r,
	className: e("mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", t),
	...n
}));
Nt.displayName = "TabsContent";
//#endregion
//#region src/components/ui/calendar.tsx
function Pt({ className: t, classNames: n, showOutsideDays: r = !0, ...i }) {
	return /* @__PURE__ */ u(M, {
		showOutsideDays: r,
		autoFocus: !0,
		className: e("p-3", t),
		classNames: {
			day_button: "w-full h-full",
			months: "relative flex flex-col sm:flex-row",
			month: "space-y-4",
			month_caption: "flex justify-center pt-1 relative items-center",
			caption_label: "text-sm font-medium",
			nav: "space-x-1 flex items-center",
			month_grid: "w-full border-collapse space-y-1",
			weekdays: "flex",
			weekday: "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]",
			week: "flex w-full mt-2",
			day: e(Y({ variant: "ghost" }), "h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20"),
			range_end: "day-range-end",
			selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
			today: "bg-accent text-accent-foreground",
			outside: "day-outside text-muted-foreground opacity-50 aria-selected:bg-accent/50 aria-selected:text-muted-foreground aria-selected:opacity-30",
			disabled: "text-muted-foreground opacity-50",
			range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
			hidden: "invisible",
			...n
		},
		components: {
			PreviousMonthButton: (t) => /* @__PURE__ */ u(X, {
				...t,
				size: "xs",
				variant: "outline",
				className: e(Y({ variant: "outline" }), "h-6 w-6 bg-transparent p-0 opacity-50 hover:opacity-100 absolute top-1 left-1 z-10"),
				children: /* @__PURE__ */ u(v, { className: "h-4 w-4" })
			}),
			NextMonthButton: (t) => /* @__PURE__ */ u(X, {
				...t,
				size: "xs",
				variant: "outline",
				className: e(Y({ variant: "outline" }), "h-6 w-6 bg-transparent p-0 opacity-50 hover:opacity-100 absolute top-1 right-1 z-10"),
				children: /* @__PURE__ */ u(y, { className: "h-4 w-4" })
			})
		},
		...i
	});
}
Pt.displayName = "Calendar";
//#endregion
//#region src/components/ui/label.tsx
var Ft = m("text-xs text-muted-foreground font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"), It = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u("label", {
	ref: r,
	className: e(Ft(), t),
	...n
}));
It.displayName = "Label";
//#endregion
//#region src/components/ui/scroll-area.tsx
var Lt = t.forwardRef(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ d(N.Root, {
	ref: i,
	className: e("relative overflow-hidden", t),
	...r,
	children: [
		/* @__PURE__ */ u(N.Viewport, {
			className: "h-full w-full rounded-[inherit]",
			children: n
		}),
		/* @__PURE__ */ u(Rt, {}),
		/* @__PURE__ */ u(N.Corner, {})
	]
}));
Lt.displayName = "ScrollArea";
var Rt = t.forwardRef(({ className: t, orientation: n = "vertical", ...r }, i) => /* @__PURE__ */ u(N.Scrollbar, {
	ref: i,
	orientation: n,
	className: e("flex touch-none select-none transition-colors", n === "vertical" && "h-full w-2.5 border-l border-l-transparent p-px", n === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-px", t),
	...r,
	children: /* @__PURE__ */ u(N.Thumb, { className: "relative flex-1 rounded-full bg-border" })
}));
Rt.displayName = "ScrollBar";
//#endregion
//#region src/components/ui/switch.tsx
var zt = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(P.Root, {
	className: e("peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[checked]:bg-primary data-[unchecked]:bg-input", t),
	...n,
	ref: r,
	children: /* @__PURE__ */ u(P.Thumb, { className: e("pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[checked]:translate-x-5 data-[unchecked]:translate-x-0") })
}));
zt.displayName = "Switch";
//#endregion
//#region src/components/ui/textarea.tsx
var Bt = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u("textarea", {
	className: e("flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50", t),
	ref: r,
	...n
}));
Bt.displayName = "Textarea";
//#endregion
//#region src/components/ui/skeleton.tsx
function Vt({ className: t, ...n }) {
	return /* @__PURE__ */ u("div", {
		className: e("animate-pulse rounded-md bg-muted", t),
		...n
	});
}
//#endregion
//#region src/lib/debounce.ts
var Ht = (e, t) => {
	let n;
	return (r) => {
		clearTimeout(n), n = setTimeout(() => {
			e(r).catch((e) => console.error(e));
		}, t);
	};
};
//#endregion
//#region src/components/ui/comboboxList.tsx
function Ut({ options: e, setOptions: t, selectedOptions: n, setOpen: r, onSelect: a, label: s, closeOnSelect: c = !1, fitToViewport: l = !1, fetchAsyncData: f, fetchDebounce: p = 400, loadingAsync: m, minSearchChars: h = 2, translationStrings: g }) {
	let _ = o(null);
	i(() => {
		let e = requestAnimationFrame(() => {
			_.current?.focus();
		});
		return () => cancelAnimationFrame(e);
	}, []);
	let v = Ht(async (e) => {
		try {
			/* v8 ignore start -- defensive: debouncedFetch only invoked when fetchAsyncData is set */
			if (!f) return;
			/* v8 ignore stop */
			await f(e);
		} catch (e) {
			console.error("Error fetching data:", e);
		}
	}, p), y = (e) => {
		e.preventDefault(), e.target instanceof HTMLDivElement && !e.target.dataset.ischeckbox && setTimeout(() => {
			r(!1);
		});
	};
	return /* @__PURE__ */ d($, {
		shouldFilter: !f,
		filter: f ? void 0 : (e, t, n) => {
			let r = t.toLowerCase();
			return +!!n?.some((e) => e.toLowerCase().includes(r));
		},
		children: [/* @__PURE__ */ u(Ie, {
			ref: _,
			autoFocus: !0,
			placeholder: s || "",
			onValueChange: (e) => {
				f && (e.length >= h && v(e), e.length < h && t([]));
			}
		}), /* @__PURE__ */ d(Le, {
			className: l ? "max-h-none" : void 0,
			children: [/* @__PURE__ */ u(Re, { children: m ? /* @__PURE__ */ u("div", { children: g?.searching ?? "Searching..." }) : g?.nothingFound ?? "Nothing found" }), /* @__PURE__ */ u(ze, { children: e.map((t) => /* @__PURE__ */ u(Ve, {
				className: "group/checkbox",
				value: t.value,
				keywords: [t.label, t.value],
				onMouseUp: y,
				onSelect: (t) => {
					let n = e.find((e) => e.value === t);
					n && 
					/* v8 ignore stop */
					(a(n), c && r(!1));
				},
				children: /* @__PURE__ */ d("div", {
					className: "grid grid-flow-col auto-cols-auto items-center gap-2",
					children: [
						/* @__PURE__ */ u("div", {
							className: "w-6 p-0.5",
							"data-ischeckbox": !0,
							children: n.find((e) => e.value === t.value) ? /* @__PURE__ */ u(ee, {
								size: 18,
								strokeWidth: 1.75,
								className: "mr-4 group-hover/checkbox:opacity-50"
							}) : /* @__PURE__ */ u(C, {
								size: 18,
								strokeWidth: 1.75,
								className: "mr-4 opacity-0 group-hover/checkbox:opacity-50"
							})
						}),
						e.some((e) => !!e?.color || !!e?.icon || !!e?.avatar) && /* @__PURE__ */ d("div", {
							className: "w-6 justify-self-center p-0.5",
							children: [
								t?.color && !t.icon && !t.avatar && /* @__PURE__ */ u("div", { className: `items-center w-2.5 h-2.5 grow-0 shrink-0 rounded-full ${t.color}` }),
								t?.icon && !t.avatar && !t.color && /* @__PURE__ */ u(t.icon, {
									size: 18,
									...t.iconProps
								}),
								t?.avatar && !t.icon && !t.color && /* @__PURE__ */ u(Wt, { avatar: t.avatar })
							]
						}),
						/* @__PURE__ */ d("div", {
							className: "pr-0.5",
							children: [t.label, /* @__PURE__ */ u(He, { children: t.info || "" })]
						})
					]
				})
			}, t.value)) })]
		})]
	});
}
var Wt = ({ avatar: e }) => /* @__PURE__ */ u("div", {
	className: "h-3 w-3",
	children: e
}), Gt = "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2";
function Kt({ size: t = "default", variant: n, autoFocus: o, fitToViewport: c = !1, onOpenChange: f, options: p, placeholder: m, validation: h, onSelect: g, selectedOptions: _, className: v, children: y, closeOnSelect: b = !1, sortOrder: x, max: S, modal: ee = !1, fetch: C, fetchDebounce: w, minSearchChars: T, translationStrings: E }) {
	let [D, O] = s(_);
	i(() => {
		O(_);
	}, [_]);
	let [k, A] = s(!1), [j, M] = s(p || []), [N, P] = s(!1), te = J("(min-width: 768px)"), F = a(() => !S || S < 0 ? 0 : S, [S]), I = D.map((e) => e.label), ne = (e, t, n) => {
		let r = I.includes(e.label), i = I.includes(t.label);
		return r && !i ? -1 : !r && i ? 1 : e[n].localeCompare(t[n]);
	}, V = (e) => {
		if (e && p) {
			let e = x ? p.sort((e, t) => ne(e, t, x)) : p;
			M(e);
		}
		f && f(e), A(e);
	}, H = D.length > 1 ? `${D[0].label} +${D.length - 1}` : D.length ? D[0].label : void 0, U = (e) => {
		let t = D.find((t) => t.value === e.value);
		if (t && O(D.filter((t) => t.label !== e.label)), !t) {
			if (F === 1) O([e]);
			else if (!F || D.length < F) O([...D, e]);
			else return;
		}
		g(e), F === 1 && A(!1);
	}, G = r(async (e) => {
		C && 
		/* v8 ignore stop */
		(P(!0), M(await C(e)), P(!1));
	}, [C]);
	return te ? /* @__PURE__ */ d(re, {
		open: k,
		onOpenChange: V,
		modal: ee,
		children: [/* @__PURE__ */ u(L, { render: /* @__PURE__ */ u(X, {
			size: t,
			autoFocus: o,
			variant: n || "outline",
			"data-ele-placeholder": y || H ? void 0 : "true",
			"data-ele-validation": h ? "true" : void 0,
			className: e("w-fit font-sans font-normal whitespace-nowrap p-2", o && Gt, v),
			onKeyDown: (e) => {
				(e.key === "Enter" || e.key === " ") && e.stopPropagation();
			},
			children: y || (H ? /* @__PURE__ */ u("span", {
				className: "truncate",
				children: H
			}) : /* @__PURE__ */ u("span", {
				className: "text-muted-foreground truncate",
				"data-ele-placeholder": "true",
				"data-ele-validation": h ? "true" : void 0,
				children: m || ""
			}))
		}) }), /* @__PURE__ */ u(R, {
			className: e("min-w-[200px] w-fit p-0 max-w-[400px]", c && "flex flex-col max-h-(--available-height)"),
			align: "start",
			onKeyDown: (e) => {
				e.key === "Escape" && (e.stopPropagation(), A(!1));
			},
			children: /* @__PURE__ */ u(Ut, {
				options: j,
				selectedOptions: D,
				setOpen: V,
				onSelect: (e) => U(e),
				label: H,
				closeOnSelect: b,
				fitToViewport: c,
				fetchAsyncData: C ? G : void 0,
				fetchDebounce: w,
				loadingAsync: N,
				minSearchChars: T,
				setOptions: M,
				translationStrings: E
			})
		})]
	}) : /* @__PURE__ */ d(z, {
		open: k,
		onOpenChange: V,
		children: [/* @__PURE__ */ u(B, {
			asChild: !0,
			children: /* @__PURE__ */ u(X, {
				variant: "outline",
				autoFocus: o,
				className: e("justify-start px-2 font-sans font-normal whitespace-nowrap text-ellipsis", o && Gt),
				children: y || (H ? /* @__PURE__ */ u(l, { children: H }) : /* @__PURE__ */ u(l, { children: m }))
			})
		}), /* @__PURE__ */ d(W, {
			className: e(c && "max-h-[calc(100dvh-6rem)]"),
			children: [/* @__PURE__ */ u(K, {
				className: "sr-only",
				children: "Välj alternativ"
			}), /* @__PURE__ */ u("div", {
				className: e("mt-4 border-t", c && "flex min-h-0 flex-col"),
				children: /* @__PURE__ */ u(Ut, {
					options: j,
					selectedOptions: D,
					setOpen: V,
					onSelect: (e) => U(e),
					label: H,
					closeOnSelect: b,
					fitToViewport: c,
					fetchAsyncData: C ? G : void 0,
					fetchDebounce: w,
					loadingAsync: N,
					minSearchChars: T,
					setOptions: M,
					translationStrings: E
				})
			})]
		})]
	});
}
//#endregion
//#region src/components/ui/toggle.tsx
var qt = m("inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors hover:bg-muted hover:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[pressed]:bg-accent data-[pressed]:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 gap-2", {
	variants: {
		variant: {
			default: "bg-transparent",
			outline: "border border-input bg-transparent hover:bg-accent hover:text-accent-foreground"
		},
		size: {
			default: "h-10 px-3 min-w-10",
			xs: "h-7 px-2 min-w-7",
			sm: "h-9 px-2.5 min-w-9",
			lg: "h-11 px-5 min-w-11"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
}), Jt = t.forwardRef(({ className: t, variant: n, size: r, ...i }, a) => /* @__PURE__ */ u(F, {
	ref: a,
	className: e(qt({
		variant: n,
		size: r,
		className: t
	})),
	...i
}));
Jt.displayName = "Toggle";
//#endregion
//#region src/components/ui/toggle-group.tsx
var Yt = t.createContext({
	size: "default",
	variant: "default"
}), Xt = t.forwardRef(({ className: t, variant: n, size: r, type: i = "single", children: a, ...o }, s) => /* @__PURE__ */ u(te, {
	ref: s,
	multiple: i === "multiple",
	className: e("flex items-center justify-center gap-1", t),
	...o,
	children: /* @__PURE__ */ u(Yt.Provider, {
		value: {
			variant: n,
			size: r
		},
		children: a
	})
}));
Xt.displayName = "ToggleGroup";
var Zt = t.forwardRef(({ className: n, children: r, variant: i, size: a, ...o }, s) => {
	let c = t.useContext(Yt);
	return /* @__PURE__ */ u(F, {
		ref: s,
		className: e(qt({
			variant: c.variant || i,
			size: c.size || a
		}), n),
		...o,
		children: r
	});
});
Zt.displayName = "ToggleGroupItem";
//#endregion
//#region src/components/ui/sonner.tsx
var Qt = ({ ...e }) => {
	let { theme: t = "system" } = I();
	return /* @__PURE__ */ u(ne, {
		theme: t,
		className: "toaster group",
		toastOptions: { classNames: {
			toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
			description: "group-[.toast]:text-muted-foreground",
			actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
			cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground"
		} },
		...e
	});
};
//#endregion
export { de as Alert, pe as AlertDescription, fe as AlertTitle, Ue as Avatar, Ge as AvatarFallback, We as AvatarImage, Dt as Badge, X as Button, se as ButtonGroup, ce as ButtonGroupSeparator, Pt as Calendar, me as Checkbox, Kt as ComboBox, $ as Command, Fe as CommandDialog, Re as CommandEmpty, ze as CommandGroup, Ie as CommandInput, Ve as CommandItem, Le as CommandList, Be as CommandSeparator, He as CommandShortcut, Te as Dialog, Oe as DialogClose, Ae as DialogContent, Pe as DialogDescription, Me as DialogFooter, je as DialogHeader, ke as DialogOverlay, Ee as DialogPortal, Ne as DialogTitle, De as DialogTrigger, z as Drawer, H as DrawerClose, W as DrawerContent, q as DrawerDescription, ie as DrawerFooter, G as DrawerHeader, U as DrawerOverlay, V as DrawerPortal, K as DrawerTitle, B as DrawerTrigger, et as DropdownMenu, ut as DropdownMenuCheckboxItem, ct as DropdownMenuContent, nt as DropdownMenuGroup, lt as DropdownMenuItem, ft as DropdownMenuLabel, it as DropdownMenuRadioGroup, dt as DropdownMenuRadioItem, pt as DropdownMenuSeparator, mt as DropdownMenuShortcut, rt as DropdownMenuSub, st as DropdownMenuSubContent, ot as DropdownMenuSubTrigger, tt as DropdownMenuTrigger, le as Input, It as Label, re as Popover, R as PopoverContent, ae as PopoverDrawer, L as PopoverTrigger, Lt as ScrollArea, Rt as ScrollBar, gt as Select, St as SelectContent, _t as SelectGroup, wt as SelectItem, yt as SelectTrigger, vt as SelectValue, Z as Separator, he as Sheet, ve as SheetClose, be as SheetContent, we as SheetDescription, Se as SheetFooter, xe as SheetHeader, Q as SheetOverlay, ge as SheetPortal, Ce as SheetTitle, _e as SheetTrigger, Vt as Skeleton, zt as Switch, Ke as Table, Je as TableBody, Qe as TableCell, Ze as TableHead, qe as TableHeader, Xe as TableRow, At as Tabs, Nt as TabsContent, jt as TabsList, Mt as TabsTrigger, Bt as Textarea, Qt as Toaster, Jt as Toggle, Xt as ToggleGroup, Zt as ToggleGroupItem, kt as Tooltip, Y as buttonVariants, J as useMediaQuery };

//# sourceMappingURL=index.es.js.map